"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Button = ({ label, handleClick, id, isReadOnly }) => {
    const opts = {};
    if (isReadOnly)
        opts.disabled = 'disabled';
    return (react_1.default.createElement("div", { className: "string-Button" },
        react_1.default.createElement("button", { ...opts, id: id, onClick: handleClick }, label),
        isReadOnly && react_1.default.createElement("span", null, "* read only")));
};
exports.default = Button;
//# sourceMappingURL=Button.js.map